import React from "react";
import { connect } from "react-redux";
import AdDescription from "./AdDescription";
import AdFaq from "./AdFaq";
import AdComment from "./AdComment";
import Tabs from "./Tabs";
import { I18n } from "react-redux-i18n";

class AdTab extends React.Component {
  getFaqCount = () => {
    const { ad, faqState } = this.props;

    if (ad?.Id && String(faqState.goderId) === String(ad.Id)) {
      return faqState.list.length;
    }

    return Number(ad?.FaqCount) || 0;
  };

  getCommentCount = () => {
    const { ad, commentState } = this.props;

    if (
      ad?.CommentId &&
      String(commentState.parentCommentId) === String(ad.CommentId)
    ) {
      return commentState.list.length;
    }

    return Number(ad?.CommentCount) || 0;
  };

  formatTabLabel = (label, count) => `${label} (${count})`;

  render() {
    const faqCount = this.getFaqCount();
    const commentCount = this.getCommentCount();

    return (
      <React.Fragment>
        <Tabs>
          <div label={I18n.t("ad_description")} className="col-12">
            <AdDescription />
          </div>
          <div
            label={this.formatTabLabel(I18n.t("faq_questions"), faqCount)}
            className="col-12"
          >
            <AdFaq />
          </div>
          <div
            label={this.formatTabLabel(I18n.t("comments"), commentCount)}
            className="col-12"
          >
            <AdComment />
          </div>
        </Tabs>
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    ad: reducer.ad.item,
    faqState: reducer.adFaq,
    commentState: reducer.adComment,
  };
}

export default connect(mapStateToProps)(AdTab);
